import chroma from 'chroma-js'



export const rainDomain = [ 0 , 0.3 , 0.5, 1 , 1.5, 2 , 3 , 4 , 4.8 ];
const rainColors = ['#ffffff','#b6e5f4','#7cc6df','#4aa7c5','#0888a9','#016787','#024866','#012b47','#000f2a'];

export const pxHRainColors = ['#ffffff','#0888a9',	'#012b47',	'#000f2a','#000000'];

export const temperatureDomain = [ -15, -10, -5, 0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 33, 36, 39, 41, 999];
export const temperatureColors = [
	'#616464',
	'#7e7e7e',
	'#a3a3a3',
	'#d4d4d5',
	'#0303d7',
	'#0085ff',
	'#4696f7',
	'#80e7ff',
	'#328103',
	'#11ca30',
	'#7bf960',
	'#aef890',
	'#fcff24',
	'#fbda00',
	'#ff8242',
	'#fe5e13',
	'#f90401',
	'#e00102',
	'#980100'];

export const humidityDomain = [ 0 , 50, 80 , 90, 95 , 100];
export const humidityColors = ['#ffffff','#b6e5f4','#4aa7c5','#016787','#024866','#000f2a'];

export const windDomain = [ 0 , 0.3 , 0.5, 1 , 1.5, 2 , 3 , 4 , 4.8 ];
export const windColors = ['#ffffff','#b6e5f4','#7cc6df','#4aa7c5','#0888a9','#016787','#024866','#012b47','#000f2a'];

const returnTimeDomain = [0, 2, 5, 10, 20, 50, 100, 500];
const returnTimeColors = ['#add8e6', '#c9c4c5', '#dcafa5', '#e99986', '#f38168', '#f96749', '#fd472a', '#ff0000'];

export const spiDomain = [-100,-2,-1.5,-1,1,1.5,2,100];

export const spiColors = [
	'#fb0008',
	'#e37500',
	'#f9f589',
	'#91f52c',
	'#0cb500',
	'#8dffff',
	'#017bff',
	'#0b07fa'
]
export const fireRiskDomain = [0,0.2,0.4,0.6,0.8,1];
export const fireRiskColors = ['#1a9641','#a6d96a','#ffffc0','#fdae61','#d7191c'];

export const firePropagationDomain = [ 0, 5 ,30,60,180,360,720,1140, 9999];
export const firePropagationColors = [
	'#00ffff00',
	'#f80500',
	'#ff5a14',
	'#ffe000',
	'#ffff11',
	'#d6d6d6',
	'#a0a0a0',
	'#7c7c7c',
	'#353535'
];

export const hydroDomain = [0,0.2,25,50,100,150,200,250,300];
export const hydroColors = ['#fff','#c3fbfe','#c2c5fa','#a3a7fe','#6c6afa','#272cfc','#0007e2','#0003b8','#000184']

export const statsTDomain = [-10, -5, -3, -1, 1, 3, 5, 10,100];
export const statsTColors = [
	'#646464',
	'#7c7c7c',
	'#a0a0a0',
	'#d6d6d6',
	'#ffff11',
	'#ffe000',
	'#f78443',
	'#ff5a14',
	'#f80500']

export const rainColorForMonitoring = ["#ffffff","#00ffff00","#00f0ff","#00dcff","#00c8ff","#00b4ff","#00a0ff","#008cff","#0078ff","#0064e6","#0050cd","#003cb4","#002887","#00146e","#00005f","#82006e","#91007d","#a0008c","#af009b","#be00aa","#cd00b9"].filter((v,i) => i % 2 !== 0);;
export const rainDomainForMonitoring_1_3_6 = [0,0.2,1,2,5,10,15,20,25,30,35,40,50,60,70,80,90,100,120,150,180];
export const rainDomainForMonitoring_24 = [0,1,2.5,5,10,15,20,25,30,40,50,60,70,80,90,100,120,150,200,250,300];

export const radarSriColors = [[181,241,240],[181,241,240],[174,235,241],[166,229,241],[159,222,242],[151,216,242],[144,210,243],[136,204,244],[129,197,244],[122,191,245],[114,180,245],[107,179,246],[99,172,247],[92,166,247],[84,160,248],[77,154,248],[69,147,249],[62,141,250],[55,135,250],[47,129,251],[40,122,251],[32,116,252],[25,110,252],[17,104,253],[10,97,254],[2,91,254],[6,92,248],[16,99,238],[26,105,228],[36,111,218],[46,118,208],[56,124,198],[66,130,188],[76,137,178],[86,143,168],[96,149,158],[106,156,148],[116,162,138],[126,168,128],[136,174,118],[146,181,108],[156,187,98],[166,194,88],[176,200,78],[186,206,68],[196,213,58],[206,219,48],[216,225,38],[226,232,28],[236,238,18],[246,244,8],[255,249,0],[255,248,0],[255,246,0],[255,244,0],[255,243,0],[255,241,0],[255,239,0],[255,238,0],[255,236,0],[255,234,0],[255,233,0],[255,231,0],[255,230,0],[255,228,0],[255,226,0],[255,225,0],[255,223,0],[255,221,0],[255,220,0],[255,218,0],[255,216,0],[255,215,0],[255,213,0],[255,212,0],[255,210,0],[255,208,0],[255,207,0],[255,205,0],[255,203,0],[255,202,0],[255,200,0],[255,199,0],[255,197,0],[255,195,0],[255,194,0],[255,192,0],[255,190,0],[255,189,0],[255,187,0],[255,185,0],[255,184,0],[255,182,0],[255,181,0],[255,179,0],[255,177,0],[255,176,0],[255,174,0],[255,172,0],[255,171,0],[255,169,0],[255,167,0],[254,165,0],[254,162,2],[254,159,4],[254,156,5],[254,153,7],[253,150,9],[253,147,10],[253,145,12],[253,142,14],[253,139,15],[252,136,17],[252,133,19],[252,130,20],[252,127,22],[252,124,24],[251,121,25],[251,118,27],[251,115,29],[251,112,30],[251,109,32],[250,106,34],[250,103,35],[250,100,37],[250,97,39],[250,94,40],[250,91,42],[249,88,44],[249,85,45],[249,82,47],[249,79,49],[249,76,50],[248,73,52],[248,70,54],[248,67,55],[248,64,57],[248,61,59],[247,58,60],[247,55,62],[247,52,64],[247,49,65],[247,46,67],[246,43,69],[246,40,70],[246,37,72],[246,35,74],[246,32,75],[245,29,77],[245,26,79],[245,23,80],[245,20,82],[245,17,84],[245,17,86],[245,20,89],[245,22,92],[245,25,95],[245,27,97],[246,30,100],[246,32,103],[246,35,106],[246,37,109],[246,40,112],[247,42,114],[247,45,117],[247,47,120],[247,50,123],[247,53,126],[248,55,128],[248,58,131],[248,60,134],[248,63,137],[248,65,140],[249,68,142],[249,70,145],[249,73,148],[249,75,151],[249,78,154],[250,81,157],[250,83,159],[250,86,162],[250,88,165],[250,91,168],[251,93,171],[251,96,173],[251,98,176],[251,101,179],[251,103,182],[252,106,185],[252,108,188],[252,111,190],[252,114,193],[252,116,196],[252,119,199],[253,121,202],[253,124,204],[253,126,207],[253,129,210],[253,131,213],[254,134,216],[254,136,218],[254,139,221],[254,141,224],[254,144,227],[253,142,228],[252,140,228],[250,137,228],[249,134,229],[247,132,229],[246,129,229],[244,127,230],[243,124,230],[241,121,230],[240,119,231],[238,116,231],[237,113,231],[235,111,232],[234,108,232],[232,105,232],[231,103,232],[229,100,233],[228,98,233],[226,95,233],[224,92,234],[223,90,234],[221,87,234],[220,84,235],[218,82,235],[217,79,235],[215,76,236],[214,74,236],[212,71,236],[211,69,237],[209,66,237],[208,63,237],[206,61,238],[205,58,238],[203,55,238],[202,53,238],[200,50,239],[199,47,239],[197,45,239],[196,42,240],[194,40,240],[193,37,240],[191,34,241],[190,32,241],[188,29,241],[187,26,242],[185,24,242],[184,21,242],[182,18,243],[181,16,243],[179,13,243],[178,11,244],[176,9,245]];
export const radarDefaultDomain = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255];

export const meteosatSriColors = [[254,254,254],[253,253,253],[252,252,252],[251,251,251],[250,250,250],[249,249,249],[248,248,248],[247,247,247],[246,246,246],[245,245,245],[244,244,244],[243,243,243],[242,242,242],[241,241,241],[240,240,240],[239,239,239],[238,238,238],[237,237,237],[236,236,236],[235,235,235],[234,234,234],[233,233,233],[232,232,232],[231,231,231],[230,230,230],[229,229,229],[228,228,228],[227,227,227],[226,226,226],[225,225,225],[224,224,224],[223,223,223],[222,222,222],[221,221,221],[220,220,220],[219,219,219],[218,218,218],[217,217,217],[216,216,216],[215,215,215],[214,214,214],[213,213,213],[212,212,212],[211,211,211],[210,210,210],[209,209,209],[208,208,208],[207,207,207],[206,206,206],[205,205,205],[204,204,204],[203,203,203],[202,202,202],[201,201,201],[200,200,200],[199,199,199],[198,198,198],[197,197,197],[196,196,196],[195,195,195],[194,194,194],[193,193,193],[192,192,192],[191,191,191],[190,190,190],[189,189,189],[188,188,188],[187,187,187],[186,186,186],[185,185,185],[184,184,184],[183,183,183],[182,182,182],[181,181,181],[180,180,180],[179,179,179],[178,178,178],[177,177,177],[176,176,176],[175,175,175],[174,174,174],[173,173,173],[172,172,172],[171,171,171],[170,170,170],[169,169,169],[168,168,168],[167,167,167],[166,166,166],[165,165,165],[164,164,164],[163,163,163],[162,162,162],[161,161,161],[160,160,160],[159,159,159],[158,158,158],[157,157,157],[156,156,156],[155,155,155],[154,154,154],[153,153,153],[152,152,152],[151,151,151],[150,150,150],[149,149,149],[148,148,148],[147,147,147],[146,146,146],[145,145,145],[144,144,144],[143,143,143],[142,142,142],[141,141,141],[140,140,140],[139,139,139],[138,138,138],[137,137,137],[136,136,136],[135,135,135],[134,134,134],[133,133,133],[132,132,132],[131,131,131],[130,130,130],[129,129,129],[128,128,128],[127,127,127],[126,126,126],[125,125,125],[124,124,124],[123,123,123],[122,122,122],[121,121,121],[120,120,120],[119,119,119],[118,118,118],[117,117,117],[116,116,116],[115,115,115],[114,114,114],[113,113,113],[112,112,112],[111,111,111],[110,110,110],[109,109,109],[108,108,108],[107,107,107],[106,106,106],[105,105,105],[104,104,104],[103,103,103],[102,102,102],[101,101,101],[100,100,100],[99,99,99],[98,98,98],[97,97,97],[96,96,96],[95,95,95],[94,94,94],[93,93,93],[92,92,92],[91,91,91],[90,90,90],[89,89,89],[88,88,88],[87,87,87],[86,86,86],[85,85,85],[84,84,84],[83,83,83],[82,82,82],[81,81,81],[80,80,80],[79,79,79],[78,78,78],[77,77,77],[76,76,76],[75,75,75],[74,74,74],[73,73,73],[72,72,72],[71,71,71],[70,70,70],[69,69,69],[68,68,68],[67,67,67],[66,66,66],[65,65,65],[64,64,64],[63,63,63],[62,62,62],[61,61,61],[60,60,60],[59,59,59],[58,58,58],[57,57,57],[56,56,56],[55,55,55],[54,54,54],[53,53,53],[52,52,52],[51,51,51],[50,50,50],[49,49,49],[48,48,48],[47,47,47],[46,46,46],[45,45,45],[44,44,44],[43,43,43],[42,42,42],[41,41,41],[40,40,40],[39,39,39],[38,38,38],[37,37,37],[36,36,36],[35,35,35],[34,34,34],[33,33,33],[32,32,32],[31,31,31],[30,30,30],[29,29,29],[28,28,28],[27,27,27],[26,26,26],[25,25,25],[24,24,24],[23,23,23],[22,22,22],[21,21,21],[20,20,20],[19,19,19],[18,18,18],[17,17,17],[16,16,16],[15,15,15],[14,14,14],[13,13,13],[12,12,12],[11,11,11],[10,10,10],[9,9,9],[8,8,8],[7,7,7],[6,6,6],[5,5,5],[4,4,4],[3,3,3],[2,2,2],[1,1,1],[0,0,0]];
export const meteosatDefaultDomain = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254];

export const wrfRAINColors = [
	'#ffffff', '#abffab', '#57ff57',
	'#24ff57', '#12ffab', '#00ffff',
	'#0099d5', '#0033ab', '#2000a0',
	'#6000b4', '#a000c8', '#c65c78',
	'#ecb828', '#ffd300', '#ffad00',
	'#ff8700', '#f55100', '#eb1b00',
	'#d50000', '#b30000', '#910000'
];
export const wrfWINDColors = [
	'#010896', '#022abf',
	'#034ce8', '#047bfc',
	'#05b8fa', '#0aeff5',
	'#2bf8d4', '#4efcaf',
	'#7cfe83', '#b5fd4f',
	'#e8f61f', '#f3af13',
	'#f9620c', '#e33007',
	'#b21b04', '#810601'
];
export const wrfSLPColors = [
	'#6c00ff', '#5900ff', '#4600ff',
	'#3300ff', '#2317ff', '#184dff',
	'#0d83ff', '#02b8ff', '#14cfc2',
	'#2ce17a', '#43f233', '#62ff00',
	'#92ff00', '#c1ff00', '#f1ff00',
	'#ffdd00', '#ffad00', '#ff7d00',
	'#ff5100', '#ff3d00', '#ff2900',
	'#ff1500', '#ff0a16', '#ff073e',
	'#ff0365', '#ff008c'
];
export const wrfRHColors = [
	'#ffffff', '#fffba1', '#fff743',
	'#def722', '#9cfb3e', '#5aff5a',
	'#36e986', '#12d3b2', '#00c0d3',
	'#00b0e9', '#00a0ff', '#0c78ff',
	'#1850ff', '#484ad4', '#9c667e',
	'#f08228', '#f04e4c', '#f01a70',
	'#e00090', '#c000ac', '#a000c8'
];
export const wrfTEMP2MColors = [
	'#ffffff', '#dfeddf', '#bfdbbf', '#9fc99f',
	'#80b780', '#60a460', '#409240', '#208020',
	'#006e00', '#207900', '#408300', '#608e00',
	'#7f9900', '#9fa300', '#bfae00', '#dfb800',
	'#ffc300', '#ffb000', '#ff9e00', '#ff8b00',
	'#ff7800', '#ff6500', '#ff5200', '#ff4000',
	'#ff2d00', '#ec2700', '#d82200', '#c51c00',
	'#b21700', '#9e1100', '#8b0b00', '#770600',
	'#640000', '#770020', '#8b0040', '#9e0060',
	'#b20080', '#c5009f', '#d800bf', '#ec00df',
	'#ff00ff'
];
export const wrfCINColors = [
	'#9a00ff', '#5f00ff', '#2500fe',
	'#1310fe', '#453bfe', '#7765fe',
	'#5e99b6', '#2ccf55', '#09ff0a',
	'#54ff54', '#9eff9e', '#ceff9e',
	'#e5ff54', '#fcff0a', '#ffaa01',
	'#fe4900', '#f70a0a', '#da3131',
	'#bd5757', '#bf7c7c', '#d49fa0',
	'#e9c2c3'
];
export const wrfTPWColors = [
	'#ffffff', '#8fff8f',
	'#35ff57', '#12ffab',
	'#00ddf1', '#0055b9',
	'#2000a0', '#7500bb',
	'#b93d93', '#ecb828',
	'#ffc600', '#ff9400',
	'#f55100', '#e41200',
	'#be0000', '#910000'
];
export const wrfCAPEColors = [
	'#d42721', '#d63a25', '#d74d29',
	'#d9612c', '#da7430', '#dc8734',
	'#e29e39', '#e9b63f', '#efcd44',
	'#f6e54a', '#fcfc4f', '#e8fc4c',
	'#d5fc49', '#c1fd46', '#aefd43',
	'#9afd40', '#97fd4c', '#95fe58',
	'#92fe65', '#90ff71', '#8dff7d',
	'#8eff97', '#8fffb0', '#90ffca',
	'#91ffe3', '#92fffd', '#86e2fc',
	'#7ac6fb', '#6ea9fb', '#628dfa',
	'#5670f9', '#4f5af9', '#4844f9',
	'#412dfa', '#3a17fa', '#3301fa'
];

export const wrfRAINDomain = [
	0,  1,  2,  3,  4,  5,  6,
	7,  8,  9, 10, 11, 12, 13,
	14, 15, 16, 17, 18, 19, 20
].map(n => n*5);

export const wrfWINDDomain = [
	0,  1,  2,  3,  4,  5,  6,  7,  8,
	9, 10, 11, 12, 13, 14, 15
].map(n => n*10);

export const wrfSLPDomain = [
	80,  81, 82, 83,  84,  85,  86,  87,
	88,  89, 90, 91,  92,  93,  94,  95,
	96,  97, 98, 99, 100, 101, 102, 103,
	104, 105
].map(n => n*10);

export const wrfRHDomain = [
	0,  1,  2,  3,  4,  5,  6,
	7,  8,  9, 10, 11, 12, 13,
	14, 15, 16, 17, 18, 19, 20
].map(n => n*5);

export const wrfTEMP2MDomain = [
	0,  1,  2,  3,  4,  5,  6,  7,  8,  9,
	10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
	20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
	30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
	40
].map(n => (n * 2) + 243.15); //.map(n => n + 273.15);

export const wrfCINDomain = [
	-20, -19, -18, -17, -16, -15, -14,
	-13, -12, -11, -10,  -9,  -8,  -7,
	-6,  -5,  -4,  -3,  -2,  -1,   0,
	1
].map(n => n*100);

export const wrfTPWDomain = [
	0,  1,  2,  3,  4,  5,  6,
	7,  8,  9, 10, 11, 12, 14, 14, 15
].map(n => n*10);
export const wrfCAPEDomain = [
	0,  1,  2,  3,  4,  5,  6,  7,  8,
	9, 10, 11, 12, 13, 14, 15, 16, 17,
	18, 19, 20, 21, 22, 23, 24, 25, 26,
	27, 28, 29, 30, 31, 32, 33, 34, 35
].map(n => n*100);

const colorMap = {
	'Temperatura': temperatureColors,
	'Umidità': humidityColors,
	'Vento': windColors,
	'Pluviometro': rainColors,
	'TempiDiRitorno': returnTimeColors
}
const domainMap = {
	'Temperatura': temperatureDomain,
	'Umidità': humidityDomain,
	'Vento': windDomain,
	'Pluviometro': rainDomain,
	'TempiDiRitorno': returnTimeDomain
}

const layerMap = {
	'T': 'Temperatura',
	'I': 'Idrometro',

	'P20M': 'Pluviometro',
	'P40M':'Pluviometro',
	'P1H': 'Pluviometro',
	'P3H': 'Pluviometro',
	'P6H': 'Pluviometro',
	'P12H': 'Pluviometro',
	'P24H': 'Pluviometro',

	"IG12H": 'Umidità',
	"IG24H": 'Umidità',
	"VS12H": 'Vento',
	"VS24H": 'Vento',

	'TempiDiRitorno' : 'TempiDiRitorno'
}
const translateDomain = (inputDomain, newBoundaries) => {
	let increment = (newBoundaries[1] - newBoundaries[0])/ (inputDomain.length - 1);
	return [...Array(inputDomain.length ).keys()].map(i =>
		Math.round((newBoundaries[0] + i*increment) * 10) / 10
	);
}
const fun = x => {
	if (x <= 0) {
		return '#00ffff00';
	} else if (x > 0 && x <= 5) {
		return '#f80500'
	} else if (x > 5 && x <= 30) {
		return '#ff5a14'
	} else if (x > 30 && x <= 60) {
		return '#ffe000'
	} else if (x > 60 && x <= 180) {
		return '#ffff11'
	} else if (x > 180 && x <= 360) {
		return '#d6d6d6'
	} else if (x > 360 && x <= 720) {
		return '#a0a0a0'
	} else if (x > 720 && x <= 1140) {
		return '#7c7c7c'
	} else return '#353535';
}
export const masterHues = [240, 0, 180, 120, 60, 300];

export default class ChromaticScale {
	static getEvenSpacedColor = (number) => `hsl(${(number * 137.508)+231},90%,50%)`;
	static getMasterColor = hue => Number.isInteger(hue) ?  "hsla(" + hue % 360 + ", 60%, 60%, 1)" : 'grey';
	static getColorAroundHue = (i, lenght, hue) =>
		Number.isInteger(hue) ? (lenght === 1 ? this.getMasterColor(hue) : "hsla(" + ((hue - 15) + (Math.round(30 / (lenght -1)) * i)) % 360 + ", 60%, 60%, 1)") : 'grey';

	static getScale = (shortlayer) => {
		return chroma.scale(colorMap[layerMap[shortlayer]]).domain( this.getCurrentDomain(shortlayer), "log");
	}

	static getRainScaleByTimescale = timescale =>{
		switch (timescale){

			case 'P_ESTIMATED_1H':
			case 'P1H':
			case 'P3H':
			case 'P6H':
				return chroma.scale(rainColorForMonitoring).domain(rainDomainForMonitoring_1_3_6);
			case 'P_DAILY':
			case 'P12H':
			case 'P24H':
				return chroma.scale(rainColorForMonitoring).domain(rainDomainForMonitoring_24);
			default:
				return chroma.scale(rainColorForMonitoring).domain(rainDomainForMonitoring_24);
		}
	}
	static getRainDomainByTimescale = timescale =>{
		switch (timescale){

			case 'P_ESTIMATED_1H':
			case 'P1H':
			case 'P3H':
			case 'P6H':
				return rainDomainForMonitoring_1_3_6;
			case 'P_DAILY':
			case 'P12H':
			case 'P24H':
				return rainDomainForMonitoring_24;
			default:
				return rainDomainForMonitoring_24;
		}
	}


	static getSPIScale = () => {
		return chroma.scale(spiColors).classes(spiDomain);
	}
	static getSPIScaleGradient = () => {
		return chroma.scale(spiColors).domain(spiDomain);
	}

	static getFireRiskScale = () => {
		return chroma.scale(fireRiskColors).classes(fireRiskDomain);
	}

	static getFirePropagationScale = (x) => {

		return fun;

		/*	return chroma.scale(firePropagationColors).classes(firePropagationDomain);*/
	}

	static getIdrologicoScale = () => {
		return chroma.scale(hydroColors).classes(hydroDomain);
	}

	static getTemperatureStatsScale = () => {
		return chroma.scale(statsTColors).classes(statsTDomain);
	}

	static getCurrentDomain = (currentShortLayer) => {
		const category = layerMap[currentShortLayer];

		if (['Umidità','Vento','Pluviometro'].includes(category)) {
			const unit = currentShortLayer.substring(currentShortLayer.length - 1, currentShortLayer.length);
			const num = currentShortLayer.match(/\d+/g).map(Number);
			const minutesNumber = (unit === 'H') ? 60 * num : num;
			return domainMap[category].map(x => x * minutesNumber);
		} else {
			return domainMap[category];
		}
	}

	static getDomainBySensorCategory = (category) => {
		switch (category) {
			case 'CC':
				return temperatureDomain;
			case 'SSP':
				return temperatureDomain;
			case 'TC':
				return temperatureDomain;
			case 'PR':
				return temperatureDomain;
			case 'T':
				return temperatureDomain;
			case 'BA':
				return temperatureDomain;
			case 'IG':
				return humidityDomain;
			case 'F':
				return temperatureDomain;
			case 'IGS':
				return temperatureDomain;
			case 'IP':
				return temperatureDomain;
			case 'C':
				return temperatureDomain;
			case 'N':
				return temperatureDomain;
			case 'MR':
				return temperatureDomain;
			case 'R':
				return temperatureDomain;
			case 'TI':
				return temperatureDomain;
			case 'I':
				return hydroDomain;
			case 'B':
				return temperatureDomain;
			case 'WV':
			case 'WS':
			case 'WR':
				return windDomain;
			case 'SRI':
				return translateDomain(radarDefaultDomain, [0, 100]);
			case 'VMI':
			case 'CAPPI2':
			case 'CAPPI3':
			case 'CAPPI4':
			case 'CAPPI5':
				return translateDomain(radarDefaultDomain, [-20, 60]);
			case 'SRT1':
				return translateDomain(radarDefaultDomain, [0, 200]);
			case 'SRT3':
				return translateDomain(radarDefaultDomain, [0, 300]);
			case 'SRT6':
				return translateDomain(radarDefaultDomain, [0, 400]);
			case 'SRT12':
				return translateDomain(radarDefaultDomain, [0, 500]);
			case 'SRT24':
				return translateDomain(radarDefaultDomain, [0, 600]);
			case "METEOSAT":
				return meteosatDefaultDomain;
			case "PM_IR_108":
				return meteosatDefaultDomain; // fixme
			case 'TEMP2M':
				return wrfTEMP2MDomain;
			case "RAIN":
			case "RAIN3H":
			case "RAIN12H":
				return wrfRAINDomain
			case "WIND":
				return wrfWINDDomain;
			case "SLP":
				return wrfSLPDomain;
			case "RH":
				return wrfRHDomain;
			case "CIN":
				return wrfCINDomain;
			case "TPW":
				return wrfTPWDomain;
			case "CAPE":
				return wrfCAPEDomain;
			default:
			{
				if (layerMap[category]){
					return this.getScale(category);
				}
				return temperatureDomain
			}
				;
		}
	}
	static getScaleBySensorCategory = (category) => {
		switch (category) {
			case 'CC':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'SSP':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'P':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'TC':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'PR':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'T':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'BA':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'IG':
				return chroma.scale(humidityColors).domain(humidityDomain);
			case 'F':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'IGS':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'IP':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'C':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'N':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'MR':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'R':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'TI':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'I':
				return chroma.scale(hydroColors).domain(hydroDomain);
			case 'B':
				return chroma.scale(temperatureColors).domain(temperatureDomain);
			case 'WV':
			case 'WS':
			case 'WR':
				return chroma.scale(windColors).domain(windDomain);
			// RADAR
			case 'SRI':
				return chroma.scale(radarSriColors).domain(translateDomain(radarDefaultDomain, [0, 100]));
			case 'VMI':
			case 'CAPPI2':
			case 'CAPPI3':
			case 'CAPPI4':
			case 'CAPPI5':
				return chroma.scale(radarSriColors).domain(translateDomain(radarDefaultDomain, [-20, 60]));
			case 'SRT1':
				return chroma.scale(radarSriColors).domain(translateDomain(radarDefaultDomain, [0, 200]));
			case 'SRT3':
				return chroma.scale(radarSriColors).domain(translateDomain(radarDefaultDomain, [0, 300]));
			case 'SRT6':
				return chroma.scale(radarSriColors).domain(translateDomain(radarDefaultDomain, [0, 400]));
			case 'SRT12':
				return chroma.scale(radarSriColors).domain(translateDomain(radarDefaultDomain, [0, 500]));
			case 'SRT24':
				return chroma.scale(radarSriColors).domain(translateDomain(radarDefaultDomain, [0, 600]));
			case 'RADAR':
				return chroma.scale(radarSriColors).domain(radarDefaultDomain);
			case "METEOSAT":
				return chroma.scale(meteosatSriColors).domain(meteosatDefaultDomain);
			case "PM_IR_108":
				return chroma.scale(meteosatSriColors).domain(meteosatDefaultDomain); // fixme
			case 'TEMP2M':
				return chroma.scale(wrfTEMP2MColors).domain(wrfTEMP2MDomain);
			case "RAIN":
			case "RAIN3H":
			case "RAIN12H":
				return chroma.scale(wrfRAINColors).domain(wrfRAINDomain);
			case "WIND":
				return chroma.scale(wrfWINDColors).domain(wrfWINDDomain);
			case "SLP":
				return chroma.scale(wrfSLPColors).domain(wrfSLPDomain);
			case "RH":
				return chroma.scale(wrfRHColors).domain(wrfRHDomain);
			case "CIN":
				return chroma.scale(wrfCINColors).domain(wrfCINDomain);
			case "TPW":
				return chroma.scale(wrfTPWColors).domain(wrfTPWDomain);
			case "CAPE":
				return chroma.scale(wrfCAPEColors).domain(wrfCAPEDomain);
			default:
				return chroma.scale(temperatureColors).domain(temperatureDomain);
		}
	}

}
